import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import classes from "./HeSuccess.module.css";
import axios from "axios";

const HeSuccess = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const msisdn = searchParams.get("msisdn") || "";
    const success = searchParams.get("success") || "";
    const clickId = searchParams.get("ClickID") || "";
    const channelId = searchParams.get("ChannelID") || "";
    const opSPID = searchParams.get("opSPID") || "";
    const languageId = searchParams.get("LanguageID") || "";
    const additionalparameter1 = searchParams.get("additionalparameter1") || "";
    const additionalparameter2 = searchParams.get("additionalparameter2") || "";

    console.log("HE Success Params:", {
        msisdn,
        success,
        clickId,
        channelId,
        opSPID,
        languageId,
        additionalparameter1,
        additionalparameter2,
    });

    const printLogs = async () => {
        try {
            console.log(window.location.href, 'pah');
            const response = await axios.post('/print-logs', {
                request: "HE Success Page Logs",
                response: window.location.href
            })
            console.log(response, 'response-');
        } catch (error) {
            console.log(error, 'error-');
        }
    }

    useEffect(() => {
        printLogs();
    }, []);

    const handleEnjoyGaming = () => {
        window.location.href = "https://asiacell.door2game.com/";
    };

    return (
        <div className={classes.page}>
            <div className={classes.card}>
                <div className={classes.icon}>✓</div>

                <h1 className={classes.title}>Subscription Successful</h1>

                <p className={classes.description}>
                    You have successfully subscribed.
                </p>

                {msisdn && (
                    <p className={classes.msisdn}>
                        Mobile Number: <span>{msisdn}</span>
                    </p>
                )}

                <p className={classes.subText}>
                    Click on the button below to enjoy gaming.
                </p>

                <button className={classes.button} onClick={handleEnjoyGaming}>
                    Enjoy Gaming
                </button>
            </div>
        </div>
    );
};

export default HeSuccess;